export function maps() {
    return new Promise((resolve) => {
        const mapElements = document.querySelectorAll('[data-custom-map]'),
            loadMaps = async () => {
                let { initMaps } = await import(/* webpackMode: "lazy" */ './map.async.js');

                initMaps(mapElements);
                resolve();
            },
            hasBorlabs = 'BorlabsCookie' in window,
            // v3 API uses Consents.hasConsent(), v2 used checkCookieConsent()
            hasConsent = () => window.BorlabsCookie?.Consents?.hasConsent('googlemaps') ?? false;

        if (!mapElements.length) {
            return;
        }

        if (!hasBorlabs || hasConsent()) {
            loadMaps();
        } else {
            const onConsentSaved = () => {
                if (hasConsent()) {
                    window.removeEventListener('borlabs-cookie-consent-saved', onConsentSaved);
                    loadMaps();
                }
            };

            window.addEventListener('borlabs-cookie-consent-saved', onConsentSaved);
        }
    });
}
